
// src/App.js
import React from 'react';
import { Provider } from 'react-redux';
import store from "./store";
import { MsalProvider } from "@azure/msal-react";
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { GuestManagerApprovalGate } from './components/GuestManagerApprovalGate';
import AuthenticatedApp from './AuthenticatedApp'; 

const App = ({ pca }) => {
    return (
        <Provider store={store}>
            <MsalProvider instance={pca}>
                <BrowserRouter>
                    <Routes>
                        {/* Public guest route (no MSAL, no Layout) */}
                        <Route path="/managerapproval" element={<GuestManagerApprovalGate />} />
                        {/* Everything else goes to the MSAL-based shell */}
                        <Route path="/*" element={<AuthenticatedApp />} />
                    </Routes>
                </BrowserRouter>
            </MsalProvider>
        </Provider>
    );
};

export default App;
